// extracted by mini-css-extract-plugin
export default {"projectButton":"ProjectButton_projectButton__JP4qz","disabled":"ProjectButton_disabled__RuOQb"};